import React from "react";
import Skills from "../components/Skills";
import { MainLayout } from "../styles/Layouts";

function SkillsPage() {
  return (
    <MainLayout>
      <Skills />
    </MainLayout>
  );
}

export default SkillsPage;
